import React,{useRef,useState} from 'react';
import API from '../api';
const message=error=>error?.response?.data?.message||error?.response?.data?.error||error?.message||'Building plan types could not be saved. Try again.';
export default function CampaignBuildingDefinitionsPanel({campaign,api=API}){
 const [context,setContext]=useState(null),[open,setOpen]=useState(false),[busy,setBusy]=useState(false),[error,setError]=useState(''),[saved,setSaved]=useState(false);
 const pending=useRef(null),base='/v1/veridian/campaigns/'+encodeURIComponent(campaign.campaign_id)+'/building-definitions';
 async function load(){const result=await api.get(base);setContext(result.data);}
 async function show(){setOpen(true);setError('');setBusy(true);try{await load();}catch(error){setError(message(error));}finally{setBusy(false);}}
 async function prepare(){
  setError('');setBusy(true);
  try{
   if(!pending.current)pending.current={action_key:window.crypto.randomUUID(),expected_account_version:context.account_version,
    expected_campaign_version:context.campaign_version,source_vocabulary_sha256:context.source_vocabulary_sha256,expected_site_version:context.geography.site_version};
   await api.post(base,pending.current);pending.current=null;setSaved(true);
   await load().catch(()=>setError('Your building plan types were saved. Reload this page to refresh them.'));
  }catch(error){setError(message(error));if(error.response?.status>=400&&error.response?.status<500){pending.current=null;await load().catch(()=>{});}}
  finally{setBusy(false);}
 }
 return <div className="vd-calendar" role="group" aria-label={'Building plans for '+campaign.name}>
  <button type="button" disabled={busy} onClick={show}>Building plans for {campaign.name}</button>
  {open&&<><h4>Building plan types</h4>
   {error&&<p role="alert">{error}</p>}
   {saved&&<p role="status">Building plan types saved. World time has not advanced.</p>}
   {context?.building_definitions&&<><p>{context.building_definitions.template_count} building types retained.</p>
    <ul>{context.building_definitions.templates.map(row=><li key={row.purpose_id}><details><summary>{row.name}</summary><p>{row.room_role_templates.join(', ')}</p></details></li>)}</ul>
    <p>Creating a building requires an available site, lawful use, materials, structural requirements and completed work.</p></>}
   {context&&!context.building_definitions&&!saved&&context.status==='DRAFT'&&<>
    {context.geography?<><p>Retain the building types and room roles available for this campaign.</p>
     <button type="button" disabled={busy} onClick={prepare}>{busy?'Saving plan types…':'Save building plan types'}</button></>:
     <p>Record the starter location first, then reopen building plans.</p>}
   </>}
   <button type="button" style={{display:'block',marginTop:8}} disabled={busy} onClick={()=>setOpen(false)}>Close building plans</button>
  </>}
 </div>;
}
